import React from 'react'
import Tittle from '../Components/Tittle'
import ImageSection from '../Components/ImageSection';
import SkillsSection from '../Components/SkillsSection';
import ServicesSection from '../Components/ServicesSection';
import design from '../img/design.svg';
import intelligence from '../img/intelligence.svg';
import gamedev from '../img/game-dev.svg';

function AboutPage() {
    return (
        <div className="AboutPage">
            <Tittle title={'About Me'} span={'About Me'} />
            <ImageSection />
            <Tittle title={'My Skills'} span={'My Skills'} />
            <div className="skillsContainer">
                <SkillsSection skill={'JavaScript(ES-6)'} progress={'70%'} width={'70%'} />
                <SkillsSection skill={'HTML-5'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'React Js'} progress={'70%'} width={'70%'} />
                <SkillsSection skill={'Node Js'} progress={'80%'} width={'80%'} />
                <SkillsSection skill={'Mongo DB'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'CSS3'} progress={'90%'} width={'90%'} />
                <SkillsSection skill={'Bootstrap'} progress={'85%'} width={'85%'} />
                <SkillsSection skill={'Java'} progress={'80%'} width={'80%'} />
                <SkillsSection skill={'Web Design'} progress={'75%'} width={'75%'} />
                <SkillsSection skill={'Tailwind CSS'} progress={'80%'} width={'80%'} />
            </div>

            <Tittle title={'Services'} span={'Services'} />
            <div className="servives-container">
                <ServicesSection image={design} title={'Full Stack Web Development'}
                    text={`I am a Full-Stack Web Developer. I try to develop the front end of a web application using React.js
                    and the back-end using Node.js with comfortable.`}
                />
                <ServicesSection image={intelligence} title={'Digital Marketing'}
                    text={`Digital Marketing – Lead Generation, Keyword Research, Email template, Email Marketing.`}
                />
                <ServicesSection image={gamedev} title={'Graphics Design'}
                    text={`Design in Photoshop& Illustrator – Visiting Card, Flyer Design, Ads Design`}
                />


            </div>

        </div>
    )
}

export default AboutPage;
